// extracted by mini-css-extract-plugin
export default {"snackbarVisible":"styles_snackbarVisible__YILJK","snackbarHidden":"styles_snackbarHidden__sjUPf","bone-skeleton":"styles_bone-skeleton__keCc7"};